import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { AiFillInfoCircle } from "react-icons/ai";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import commonUtils from "../../helpers/commonUtils";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import { MultiSelect } from "react-multi-select-component";
import CustomTextField from "../ReusableComponent/CustomTextField";
import AppConstants from "../../Constants/AppConstants";
import ConfirmationModalWithPassword from "../MessageBox/ConfirmationModalWithPassword";
const initialErrorState = {
  designation: false,
  feedback: false,
  testCriterion: false,
  hasChildren: false,
  inventorylength: false,
  isInvnrEditierbar: false,
  selectTypeTestPlan: false,
  location: false,
  shortcut: false,
};

const CreateEquipmentGroup = React.memo((props) => {
  const {
    egDetails,
    plantList,
    selectedPlantId,
    reloadEquipmentGroupList,
    closeCreatePopOver,
    setEquipmentGrpId,
    setEquipmentGrpName,
    setActiveStep,
    isSaveEqGrp,
    setIsSaveEqGrp,
    resetComponent,
    setResetComponent,
    handleCompleted,
    equipmentGrpId,
    scanOptionEqGrp,
    setScanOptionEqGrp,
    resetEquipmentForm,
    setResetEquipmentForm,
    setIsKost,
    setIsIndiviual,
    setIsEdit,
    setEgDetails,
    setShowInfo,
  } = props.data;
  const [egId, setEgId] = useState(AppConstants.DEFAULT_GUID);
  const [plantId, setPlantId] = useState(selectedPlantId);
  const [designation, setDesignation] = useState("");
  const [shortcut, setShortcut] = useState("");
  const [location, setLocation] = useState("");
  const [inventorylength, setInventorylength] = useState("");
  const [isInvnrEditierbar, setIsInvnrEditierbar] = useState(false);
  const [feedback, setFeedback] = useState(false);
  const [testCriterion, setTestCriterion] = useState("");
  const [selectTypeTestPlan, setSelectTypeTestPlan] = useState("multiple");
  const [hasChildren, sethasChildren] = useState(true);
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [scanOptionList, setScanOptionList] = useState([]);
  const [menuList, setMenuList] = useState([]);
  const [selectedMenuList, setSelectedMenuList] = useState([]);
  const [initialData, setInitialData] = useState(null);
  const [formErrorState, setFormErrorState] = useState(initialErrorState);
  const [autoFocusElement, setAutoFocusElement] = useState("");
  const [minInventoryLengh, setMinInventoryLength] = useState(0);
  const [originalTestCriteria, setOriginalTestCriteria] = useState("");
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [confirmationTitle, setConfirmationTitle] = useState("");
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [callBackFunctionData, setCallBackFunctionData] = useState("");
  const overrideStrings = {
    selectSomeItems: localization.select,
    search: localization.search,
    selectAll: localization.select + " " + localization.all,
    selectAllFiltered:
      localization.select +
      " " +
      localization.all +
      "(" +
      localization.filtered +
      ")",
    allItemsAreSelected: localization.allItemSelected,
    noOptions: localization.noOptions,
  };
  const isLocation = useRef(false);
  const isKost = useRef(false);

  const resetForm = () => {
    setEgId(AppConstants.DEFAULT_GUID);
    setDesignation("");
    setShortcut("");
    setLocation("");
    setInventorylength("");
    setIsInvnrEditierbar(false);
    setFeedback("false");
    setTestCriterion("");
    setOriginalTestCriteria("");
    sethasChildren(true);
    setSelectedMenuList([]);
    setFormErrorState(initialErrorState);
    setResetComponent(false);
  };

  useEffect(() => {
    if (shortcut.trim() != "") {
      setMinInventoryLength(shortcut.length + 4);
    }
    return () => {};
  }, [shortcut]);

  useEffect(() => {
    if (menuList.length === 0) {
      EquipmentGroupActions.getOptionEqGrp("AnlageScanOptions");
    }
  }, []);

  useEffect(() => {
    if (equipmentGrpId && egDetails === "") {
      setGlobalSpinner(true);
      EquipmentGroupActions.getParticularEqGrp(equipmentGrpId);
    }
  }, []);

  useEffect(() => {
    if (resetComponent) {
      resetForm();
    }
  }, [resetComponent]);

  useEffect(() => {
    if (scanOptionList.length > 0) {
      const tempMenuList = [];
      scanOptionList.map((row) => {
        tempMenuList.push({ label: row.text, value: row.id });
      });
      setScanOptionEqGrp(tempMenuList);
      setMenuList(tempMenuList);
    }
  }, [scanOptionList]);

  useEffect(() => {
    function getEqGrpSuccess() {
      var res = equipmentGroupStore.getPaticularEqGrpResult();
      setIsEdit(true);
      if (res && res != "") {
        commonUtils.setIsEdit(true);
      }
      intializeData(res);
      setIsKost(res.pruefKriterium.toLowerCase() === "kost" ? true : false);
      setIsIndiviual(false);
      setEgId(res.id);
      setDesignation(res.bezeichnung);
      setShortcut(res.abkuerzung);
      setLocation(res.location);
      setInventorylength(res.inventarNrLaenge);
      setIsInvnrEditierbar(res.isInvnrEditierbar);
      setFeedback(res.hastZeitRueckmeldung);
      setTestCriterion(res.pruefKriterium);
      setOriginalTestCriteria(res.pruefKriterium);
      setSelectTypeTestPlan("multiple");
      sethasChildren(res.hasChildren);
      if (
        selectedMenuList.length == 0 &&
        res.scanOptions !== null &&
        scanOptionEqGrp != null
      ) {
        let tempArray = [];
        scanOptionEqGrp.map((item) => {
          if (res.scanOptions.includes(item.value)) {
            tempArray.push({ label: item.label, value: item.value });
          }
        });
        setSelectedMenuList(tempArray);
      }
      setGlobalSpinner(false);
    }

    function getEqGrpFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_PARTICULE_EQ_GRP_SUCCESS,
      getEqGrpSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_PARTICULE_EQ_GRP_FAILURE,
      getEqGrpFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_PARTICULE_EQ_GRP_SUCCESS,
        getEqGrpSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_OPTION_EQUIP_GRP_FAILURE,
        getEqGrpFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getEqGrpOptionSuccess() {
      var res = equipmentGroupStore.getOptionEqGrpResult();

      if (res.length > 0) {
        setScanOptionList(res);
      } else {
        setScanOptionList([]);
      }
      setGlobalSpinner(false);
    }

    function getEqGrpOptionFailure() {
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_OPTION_EQUIP_GRP_SUCCESS,
      getEqGrpOptionSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_OPTION_EQUIP_GRP_FAILURE,
      getEqGrpOptionFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_OPTION_EQUIP_GRP_SUCCESS,
        getEqGrpOptionSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_OPTION_EQUIP_GRP_FAILURE,
        getEqGrpOptionFailure,
      );
    };
  }, []);

  useEffect(() => {
    if (!commonUtils.getIsErrorOnSave()) {
      setEgId(egDetails.id ? egDetails.id : AppConstants.DEFAULT_GUID);

      setDesignation(egDetails.bezeichnung ? egDetails.bezeichnung : "");
      setShortcut(egDetails.abkuerzung ? egDetails.abkuerzung : "");
      setLocation(egDetails.location ? egDetails.location : "");
      setInventorylength(
        egDetails.inventarNrLaenge ? egDetails.inventarNrLaenge : "",
      );
      setIsInvnrEditierbar(egDetails.isInvnrEditierbar ? "true" : "false");
      setFeedback(egDetails.hastZeitRueckmeldung ? "true" : "false");
      setTestCriterion(
        egDetails.pruefKriterium ? egDetails.pruefKriterium : "",
      );
      setSelectTypeTestPlan("multiple");
      sethasChildren(
        egDetails !== "" ? (egDetails.hasChildren ? true : false) : true,
      );
      if (
        egDetails !== "" &&
        egDetails.scanOptions !== null &&
        scanOptionEqGrp != null
      ) {
        const _value = egDetails.scanOptions.split(";");
        let tempArray = [];
        scanOptionEqGrp.map((item) => {
          if (_value.includes(item.value)) {
            tempArray.push({ label: item.label, value: item.value });
          }
        });
        setSelectedMenuList(tempArray);
      } else {
        setSelectedMenuList([]);
      }
      setOriginalTestCriteria(
        egDetails.pruefKriterium ? egDetails.pruefKriterium : "",
      );
      egDetails ? commonUtils.setIsEdit(true) : commonUtils.setIsEdit(false);
      intializeData(egDetails);
    }
  }, [egDetails, scanOptionList]);

  useEffect(() => {
    setPlantId(selectedPlantId);
  }, [selectedPlantId]);

  const equipmentGroupcreate = (e) => {
    let trackError = {};
    let scanoption = [];
    if (selectedMenuList.length > 0) {
      selectedMenuList.map((item) => scanoption.push(item.value));
    } else {
      menuList.map((item) => scanoption.push(item.value));
    }
    let equipmentDetails = {
      ID: egId,
      Bezeichnung:
        designation.trim() === ""
          ? (trackError["designation"] = true)
          : designation.trim(),
      Abkuerzung:
        shortcut.trim() === ""
          ? (trackError["shortcut"] = true)
          : shortcut.trim(),
      Location:
        selectTypeTestPlan === "multiple" && location === ""
          ? (trackError["location"] = true)
          : selectTypeTestPlan === "single"
            ? null
            : location.trim(),
      InventarNrLaenge: inventorylength
        ? parseInt(inventorylength)
        : (trackError["inventorylength"] = true),
      PruefKriterium:
        testCriterion === ""
          ? (trackError["testCriterion"] = true)
          : testCriterion,
      WerkID: plantId,
      IsInvnrEditierbar: isInvnrEditierbar === "true" ? true : false,
      HastZeitRueckmeldung: feedback === "true" ? true : false,
      AnlageScanOptions: scanoption,
      HasChildren:
        hasChildren === true || hasChildren === "true" ? true : false,
    };

    if (shortcut.trim() != "") {
      let tempArray = shortcut.split(";");
      let isError = false;
      let tempStringBuilder = "";
      var minLengh = 0;
      tempArray.map((s, index) => {
        if (s.length <= 5 && s.length + 4 > minLengh) {
          minLengh = s.length + 4;
        }
        if (s.length > 5) {
          toast.error(localization.inventoryNumberPrefixLengthMsg);
          isError = true;
        } else if (parseInt(inventorylength) < s.length + 4) {
          if (tempStringBuilder.trim() == "") {
            tempStringBuilder = tempStringBuilder + s;
          } else {
            tempStringBuilder = tempStringBuilder + ", " + s;
          }
          isError = true;
        }
      });

      if (isError) {
        if (tempStringBuilder.trim() != "") {
          toast.error(
            localization.inventoryLengthGt +
              " " +
              minLengh +
              " " +
              localization.reducePrefixChar +
              " " +
              tempStringBuilder,
          );
        }
        setIsSaveEqGrp(false);
        return;
      }
    }
    setFormErrorState(trackError);
    setEquipmentGrpName(designation);
    if (Object.keys(trackError).length > 0) {
      setAutoFocusElement(Object.keys(trackError)[0]);
      setIsSaveEqGrp(false);
      return;
    } else {
      if (initialData) {
        const isSame = compareObjects(equipmentDetails, initialData);
        if (isSame) {
          setIsSaveEqGrp(false);

          setActiveStep((prev) => prev + 1);
        } else {
          isLocation.current = equipmentDetails.Location ? false : true;
          isKost.current =
            equipmentDetails.PruefKriterium.toLowerCase() === "kost"
              ? true
              : false;
          if (
            (originalTestCriteria != "" &&
              originalTestCriteria.toLocaleLowerCase()) !=
            equipmentDetails.PruefKriterium.toLowerCase()
          ) {
            setOpenConfirmationModal(true);
            setConfirmationTitle(localization.testCriteriaChangeWarningTitle);
            let message = constructMessage(
              originalTestCriteria.toLocaleLowerCase(),
            );
            setConfirmationMessage(message);
            setCallBackFunctionData(equipmentDetails);
          } else {
            setGlobalSpinner(true);
            EquipmentGroupActions.createEquipmentGroup(equipmentDetails);
          }
        }
      } else {
        setGlobalSpinner(true);
        isLocation.current = equipmentDetails.Location ? false : true;
        isKost.current =
          equipmentDetails.PruefKriterium.toLowerCase() === "kost"
            ? true
            : false;
        EquipmentGroupActions.createEquipmentGroup(equipmentDetails);
      }
    }
  };

  const constructMessage = (testCriteria) => {
    return (
      <div>
        <h5>{localization.testCriteriaChangeWarningSubTitle}</h5>
        {testCriteria === "pruefgruppe" ? (
          <>
            <ul>
              <li>{localization.testGroupChangeImpact1}</li>
              <li>{localization.testGroupChangeImpact2}</li>
              <li>{localization.testGroupChangeImpact3}</li>
            </ul>
          </>
        ) : (
          <>
            <ul>
              <li>{localization.costGroupChangeImpact1}</li>
              <li>{localization.costGroupChangeImpact2}</li>
              <li>{localization.costGroupChangeImpact3}</li>
            </ul>
          </>
        )}
      </div>
    );
  };

  const onSubmitCallback = (data) => {
    setGlobalSpinner(true);
    EquipmentGroupActions.createEquipmentGroup(data);
  };

  const onCancelCallback = () => {
    setOpenConfirmationModal(false);
    setConfirmationTitle("");
    setConfirmationMessage("");
    setCallBackFunctionData("");
    setIsSaveEqGrp(false);
  };

  useEffect(() => {
    if (isSaveEqGrp) equipmentGroupcreate("any");
  }, [isSaveEqGrp]);

  useEffect(() => {
    function addOrUpdateEquipmentGroupSuccess() {
      var res = equipmentGroupStore.getAddorUpdateEquipmentGroupResult();
      toast.success(
        commonUtils.getIsEdit()
          ? localization.equipmentGroupEditedSuccessfully
          : localization.equipmentGroupAddedSuccessfully,
      );
      setEgDetails("");
      setGlobalSpinner(false);

      setEquipmentGrpId(res);

      setIsKost(isKost.current);
      setIsIndiviual(false);

      handleCompleted("equipmentGroup", true);
      setActiveStep((prev) => prev + 1);
      reloadEquipmentGroupList();
      setIsSaveEqGrp(false);
    }

    function addOrUpdateEquipmentGroupFailure() {
      var res = equipmentGroupStore.getAddorUpdateEquipmentGroupResult();
      setGlobalSpinner(false);
      toast.error(res);
      setIsSaveEqGrp(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_GROUP_SUCCESS,
      addOrUpdateEquipmentGroupSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_GROUP_FAILURE,
      addOrUpdateEquipmentGroupFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_GROUP_SUCCESS,
        addOrUpdateEquipmentGroupSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.ADDORUPDATE_EQUIPMENT_GROUP_FAILURE,
        addOrUpdateEquipmentGroupFailure,
      );
    };
  }, []);

  function intializeData(_value) {
    if (_value !== "")
      setInitialData({
        Bezeichnung: _value.bezeichnung,
        Abkuerzung: _value.abkuerzung,
        Location: _value.location,
        InventarNrLaenge: parseInt(_value.inventarNrLaenge),
        PruefKriterium: _value.pruefKriterium,
        IsInvnrEditierbar: _value.isInvnrEditierbar,
        HastZeitRueckmeldung: _value.hastZeitRueckmeldung,
        AnlageScanOptions: _value.scanOptions
          ? _value.scanOptions.split(";")
          : "",
        HasChildren: _value.hasChildren,
      });
  }

  function compareObjects(obj1, obj2) {
    for (let key in obj1) {
      if (obj2.hasOwnProperty(key)) {
        if (Array.isArray(obj1[key])) {
          if (!arraysAreEqual(obj1[key], obj2[key])) {
            return false;
          }
        } else {
          if (obj1[key] !== obj2[key]) {
            return false;
          }
        }
      }
    }
    return true;
  }

  function arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  function OnBlurEvent(event) {
    if (!formErrorState[event.target.id] && event.target.value === "") {
      let tempValue = { ...formErrorState };
      tempValue[event.target.id] = true;

      setFormErrorState(tempValue);
    }
  }

  function handleEquipmentGroupNameChange(value) {
    // Remove slash from the input value
    if (!value.includes("/")) {
      setDesignation(value);
    }
  }

  return (
    <>
      <div>
        <div>
          <div>
            <div className="row">
              <div className="col">
                <h5 id="createEquipmentGroup">
                  {!egDetails
                    ? localization.addEquipmentGroup
                    : localization.editEquipmentGroup}
                </h5>
              </div>
            </div>

            <form
              className="pt-5"
              style={{
                maxHeight: "63vh",
                overflow: " scroll",
                overflowX: " hidden",
              }}
              id="createEquipmentGroupForm"
              name="createEquipmentGroupForm"
              onSubmit={equipmentGroupcreate}
            >
              <div>
                <div className="row mr-0">
                  <div className="col pl-5">
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.plantToolTip}
                      />
                    </span>
                    <CustomTextField
                      required
                      type="select"
                      id="plant"
                      label={localization.plant}
                      value={plantId}
                      autoFocusElement={autoFocusElement}
                      error={false}
                      disabled={true}
                      options={plantList.map((item) => ({
                        value: item.id,
                        label: item.bezeichnung,
                      }))}
                    />
                  </div>
                  <div className="col pl-5">
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.inventoylengthTooltip}
                      />
                    </span>
                    <CustomTextField
                      type="select"
                      OnBlurEvent={OnBlurEvent}
                      id="inventorylength"
                      autoFocusElement={autoFocusElement}
                      label={localization.inventoryLength}
                      value={inventorylength}
                      onChange={setInventorylength}
                      error={formErrorState.inventorylength}
                      errorHandle={setFormErrorState}
                      options={[
                        {
                          value: "",
                          label: "",
                        },
                        {
                          value: 7,
                          label: 7,
                        },
                        {
                          value: 8,
                          label: 8,
                        },
                        {
                          value: 9,
                          label: 9,
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="row mr-0">
                  <div className="col pl-5">
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.EqGrpToolTip}
                      />
                    </span>
                    <CustomTextField
                      id="designation"
                      autoFocusElement={autoFocusElement}
                      required
                      type="text"
                      OnBlurEvent={OnBlurEvent}
                      label={localization.designation}
                      value={designation}
                      onChange={handleEquipmentGroupNameChange}
                      error={formErrorState.designation}
                      errorHandle={setFormErrorState}
                    />
                  </div>
                  <div className="col pl-5">
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.isinventoryEditTooltip}
                      />
                    </span>
                    <CustomTextField
                      type="select"
                      id="isInventoryEdit"
                      autoFocusElement={autoFocusElement}
                      label={localization.isInventoryEditable}
                      value={isInvnrEditierbar}
                      OnBlurEvent={OnBlurEvent}
                      error={false}
                      disabled={true}
                      options={[
                        {
                          value: true,
                          label: localization.yes,
                        },
                        {
                          value: false,
                          label: localization.no,
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="row mr-0">
                  <div className="col pl-5">
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.inventryprefixtoolTip}
                      />
                    </span>
                    <CustomTextField
                      type="text"
                      autoFocusElement={autoFocusElement}
                      required
                      id="shortcut"
                      label={localization.shortcut}
                      value={shortcut}
                      onChange={setShortcut}
                      OnBlurEvent={OnBlurEvent}
                      error={formErrorState.shortcut}
                      errorHandle={setFormErrorState}
                    />
                  </div>
                  <div className="col pl-5">
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.hasTimeFeedbackTooltip}
                      />
                    </span>
                    <CustomTextField
                      type="select"
                      label={localization.haveTimeFeedback}
                      value={feedback}
                      autoFocusElement={autoFocusElement}
                      id="feedBack"
                      OnBlurEvent={OnBlurEvent}
                      error={false}
                      disabled={true}
                      options={[
                        {
                          value: true,
                          label: localization.yes,
                        },
                        {
                          value: false,
                          label: localization.no,
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="row mr-0">
                  <div className="col pl-5">
                    {" "}
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.inspectionTypeTooltip}
                      />
                    </span>
                    <CustomTextField
                      type="select"
                      autoFocusElement={autoFocusElement}
                      required
                      id="testingType"
                      label={localization.testingType}
                      value={selectTypeTestPlan}
                      OnBlurEvent={OnBlurEvent}
                      onChange={setSelectTypeTestPlan}
                      error={false}
                      options={[
                        {
                          value: "multiple",
                          label: localization.groupEquipmentTesting,
                        },
                      ]}
                    />
                  </div>
                  <div className="col pl-5">
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.inspectionCreationtoolTip}
                      />
                    </span>
                    <CustomTextField
                      type="select"
                      autoFocusElement={autoFocusElement}
                      label={localization.testCriterion}
                      value={testCriterion}
                      OnBlurEvent={OnBlurEvent}
                      id="testCriterion"
                      onChange={setTestCriterion}
                      error={formErrorState.testCriterion}
                      errorHandle={setFormErrorState}
                      options={[
                        {
                          value: "",
                          label: "",
                        },
                        {
                          value: "kost",
                          label: localization.equipmentkost,
                        },
                        {
                          value: "pruefgruppe",
                          label: localization.pruefgruppe,
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className="row mr-0">
                  <div className="col pl-5">
                    {" "}
                    <span className="d-flex justify-content-end mb-1">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.locationTooltip}
                      />
                    </span>
                    <CustomTextField
                      type="text"
                      autoFocusElement={autoFocusElement}
                      id="location"
                      label={localization.location}
                      value={location}
                      OnBlurEvent={OnBlurEvent}
                      onChange={setLocation}
                      error={
                        selectTypeTestPlan === "multiple" &&
                        formErrorState.location
                      }
                      required={selectTypeTestPlan === "multiple"}
                      errorHandle={setFormErrorState}
                    />
                  </div>
                  <div className="col pl-5" id="createGrp">
                    <div
                      className="form-group  mb-0"
                      style={{ marginTop: "-1px" }}
                    >
                      <div className="row">
                        <div className="col">
                          <label className="form-label" htmlFor="ScanOption">
                            {localization.scanOption}
                          </label>
                        </div>{" "}
                        <div className="col d-flex justify-content-end align-items-end">
                          <AiFillInfoCircle
                            className="cursorPoint svgIcon mb-1"
                            title={localization.scanOptionTooltip}
                          />
                        </div>
                      </div>

                      <MultiSelect
                        options={menuList}
                        autosize={false}
                        value={selectedMenuList}
                        onChange={setSelectedMenuList}
                        labelledBy="Select menu..."
                        closeOnChangedValue={false}
                        overrideStrings={overrideStrings}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mr-0">
                  <div className="col pl-5">
                    {" "}
                    <span className="d-flex justify-content-end">
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.hasChildrenTooltip}
                      />
                    </span>
                    <CustomTextField
                      type="select"
                      required
                      autoFocusElement={autoFocusElement}
                      id="hasChildren"
                      OnBlurEvent={OnBlurEvent}
                      label={localization.hasChildren}
                      value={hasChildren}
                      onChange={sethasChildren}
                      error={false}
                      options={[
                        {
                          value: true,
                          label: localization.yes,
                        },
                        {
                          value: false,
                          label: localization.no,
                        },
                      ]}
                    />
                  </div>
                  <div className="col pl-5"></div>
                </div>
              </div>
              <div></div>
            </form>
          </div>
        </div>
      </div>
      {openConfirmationModal && (
        <ConfirmationModalWithPassword
          openConfirmationModal={openConfirmationModal}
          confirmationTitle={confirmationTitle}
          confirmationMessage={confirmationMessage}
          onSubmitCallback={onSubmitCallback}
          onCancelCallback={onCancelCallback}
          callBackFunctionData={callBackFunctionData}
        />
      )}
    </>
  );
});

export default CreateEquipmentGroup;
